import { Component, Vue } from "vue-property-decorator";
import UserHandler from "@/resources/mixins/graphicClient/userHandler";
import { MessageType } from "@/resources/constants/graphicClient/graphicClient";
import SpaceHandler from "@/resources/mixins/graphicClient/spaceHandler";
import SystemHandler from "@/resources/mixins/graphicClient/systemHandler";
import { mixins } from "vue-class-component";
import Loader from "../loader/loader";
import LoadApp from "@/resources/mixins/loadApp/loadApp";

@Component({})
export default class GraphicClient extends mixins(Loader, LoadApp) {
  /**
   * Receive Message from Graphic Client
   *
   * */

  async onMessage(
    messageType: string,
    message: string,
    value?: any | null
  ): Promise<void> {
    switch (messageType) {
      case MessageType.SPACE: {
        await SpaceHandler.handleMessage(
          message,
          value,
          this.$store,
          this.$vs,
          this
        );
        break;
      }
      case MessageType.USER: {
        const _userHandler = new UserHandler();
        await _userHandler.handleMessage(message, value, this.$store, this.$vs);
        break;
      }
      case MessageType.SYSTEM: {
        const _systemHandler = new SystemHandler();
        await _systemHandler.handleMessage(
          message,
          value,
          this.$store,
          this.$mixpanel
        );
        break;
      }
      default: {
        console.error(`${messageType} is not defined in onMessage method`);
        break;
      }
    }
  }

  static async sendMessage(
    messageType: string,
    message: string,
    value?: any
  ): Promise<number | undefined> {
    if (window["graphicClientMessageReceiver"] != undefined)
      return await window["graphicClientMessageReceiver"].SendMessage(
        messageType,
        message,
        value
      );
    else return undefined;
  }
}
